import { ConfigBlock } from 'components/molecules/settings/styled';
import { InputDescription, InputTitle } from 'components/atoms/styleds';
import ChipsList from 'components/molecules/ChipsList';

const SetupSettings = ({ selectedValues, onAccept, isAutoSave }) => {
  const items = [
    {
      id: 'table_reservation',
      title: 'Prenotazione tavoli',
    },
    {
      id: 'takeaway',
      title: 'Asporto',
    },
    {
      id: 'delivery',
      title: 'Delivery',
    },
  ];
  return (
    <ConfigBlock mobileP='20px 20px 0 20px' style={{ padding: '20px 20px 30px 20px', width: '100%' }}>
      <InputTitle>Imposta i tuoi servizi</InputTitle>
      <InputDescription>
        Seleziona i servizi che sono disponibili presso la tua insegna.
      </InputDescription>
      <ChipsList
        selectedList={selectedValues}
        isColumn={true}
        list={items}
        onClick={onAccept}
        onlyNative={true}
      />
    </ConfigBlock>
  );
};

export default SetupSettings;
